module.exports = __webpack_public_path__ + "static/media/makers_hardcover.c93b321f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/books/makers_hardcover.jpg
// module id = 96
// module chunks = 0